import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 575;

export const isMobileViewport = () => window.innerWidth <= MOBILE_BREAKPOINT;

const useMobileViewport = () => {
	const [isMobileBreakpoint, setIsMobileBreakpoint] = useState(
		isMobileViewport(),
	);

	useEffect(() => {
		const handleResize = () => {
			const changedBreakpoint = isMobileViewport() !== isMobileBreakpoint;
			if (changedBreakpoint === true) {
				setIsMobileBreakpoint(isMobileViewport());
			}
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [isMobileBreakpoint]);

	return isMobileBreakpoint;
};

export default useMobileViewport;
